module.exports = __webpack_public_path__ + "img/arrow-yellow.92e61ecb.svg";